import { Box, Checkbox, MenuItem, Select, Typography } from '@mui/material';
import clsx from 'clsx';
import type { CSSProperties, FC } from 'react';

import type { ProcessedImage } from 'hooks/useDocumentAttachment';

import { useStyles } from '../styles';

type Props = {
  readonly images: readonly ProcessedImage[];
  readonly onToggleSelection: (imageId: string) => void;
  readonly onUpdateSendAs: (imageId: string, sendAs: ProcessedImage['sendAs']) => void;
  readonly onViewImagePreview: (image: string) => void;
  readonly textColor: CSSProperties['color'];
};

export const ImagePreviews: FC<Props> = ({
  images,
  onToggleSelection,
  onUpdateSendAs,
  onViewImagePreview,
  textColor,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.previewContainer}>
      {images.map((image) => (
        <Box
          key={image.id}
          className={clsx(classes.previewItem, {
            [classes.previewItemSelected]: image.selected,
          })}
        >
          <Box className={classes.previewImageWrapper} onClick={() => onViewImagePreview(image.original)}>
            <img
              src={image.preview}
              alt={image.label}
              className={classes.previewImage}
            />
          </Box>
          <Box className={classes.previewFooter} onClick={() => onToggleSelection(image.id)}>
            <Box style={{ width: "100%" }}>
              <Checkbox
                checked={image.selected}
                size="small"
                className={classes.previewCheckbox}
                onChange={(event) => {
                  event.stopPropagation();
                  onToggleSelection(image.id);
                }}
                onClick={(event) => event.stopPropagation()}
              />
              <Typography
                variant="caption"
                className={classes.previewLabel}
                style={{ color: textColor }}
                onClick={(event) => {
                  event.stopPropagation();
                  onToggleSelection(image.id);
                }}
              >
                {image.label}
              </Typography>
            </Box>
            <Select
              variant="standard"
              value={image.sendAs}
              onChange={(event) => {
                event.stopPropagation();
                onUpdateSendAs(image.id, String(event.target.value) as ProcessedImage['sendAs']);
              }}
              onClick={(event) => event.stopPropagation()}
              className={classes.sendAsSelect}
              disableUnderline
              displayEmpty
              MenuProps={{
                disableScrollLock: true,
                anchorOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
              }}
            >
              <MenuItem value="" disabled>
                <Typography variant="caption">Send as</Typography>
              </MenuItem>
              <MenuItem value="Text">
                <Typography variant="caption">Text</Typography>
              </MenuItem>
              <MenuItem value="Image">
                <Typography variant="caption">Image</Typography>
              </MenuItem>
            </Select>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
